/**
 * Seed list of event host types used for the Instagram-enrichment workflow.
 * Keep this list (and order) in sync with
 * backend/server/Constants/eventHostTypes.js.
 */
export const EVENT_HOST_TYPES = [
  "Jamming",
  "Art",
  "Comedy Club",
  "Music/DJ",
  "Wellness/Yoga",
  "Workshop",
  "Standup",
  "Dance",
  "Networking",
  "Cooking",
  "Fitness",
  "Other",
];
